import { useQuery, useQueryClient } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { Project } from 'types';
import { refetchUserOnError } from 'utils/refetchUserOnError';

const getProject = async (
  projectId: string | undefined,
  signal: AbortSignal | undefined
): Promise<Project> => {
  if (!projectId || typeof projectId !== 'string') {
    return Promise.reject(new Error('Invalid projectId'));
  }
  const { data } = await customAxios.get<Project>(
    `/projects/${projectId}`,
    {
      signal,
    }
  );
  return data;
};

export const useGetProject = (projectId: string | undefined) => {
  const queryClient = useQueryClient();
  const enabled = Boolean(projectId);

  return useQuery({
    queryKey: ['projects', projectId],
    queryFn: ({ signal }) => getProject(projectId, signal),
    enabled,
    onError: (err) => {
      refetchUserOnError(err, queryClient);
    },
  });
};
